// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__1PML0","body":"App_body__33bQW"};